(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-stock-indicator"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', event => {
    const { data: { productId }, resource: { id } } = event.detail
    const elements = document.querySelectorAll(`.js-lowstock-notice[data-product-id="${productId}"]`)

    for (const element of elements) {
      element.classList[+id === +element.dataset.variantId ? 'remove': 'add']('hidden')
    }
  })
  } catch(e) { console.error(e); }
})();

})();
